/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-return-await */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Button } from '@geist-ui/react'
import { useRouter } from 'next/router'

export default function ReEnroll() {
  const router = useRouter()

  const completeReEnrollment = async () => {
    router.push('/enroll')
  }

  return (
    <Button type="success" onClick={completeReEnrollment}>
      Re-Enroll
    </Button>
  )
}
